import React, { useState, useContext, useEffect, useRef } from "react"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { ConditionContext } from "../context/conditionContext"
import { useForm } from "react-hook-form"
import { cKycSearch } from "../../services/ekycAndCkyc"
import { DataLayerIntegration, findCurrentJourneyCode } from "../services/helperFunctions"
import * as moment from "moment"
import { errorToastr, successToastr, clearToastr } from "../../services/error-handler";
import {
  dedupeCall,
  saveApplication,
  fetchAllJourneyData,
  updateUserTrackerDetails,
  verifyCaptcha,
  ckycSearchV2,
  ckycDownloadV2
} from "../../services/apiservice"
import { isIE } from 'react-device-detect';
import axios from "axios"
import * as lookup from "../../../static/lookup.json"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import reloadSrc from "../../../static/images/reload-icon.svg"


const Ckyc = props => {
  const [showModal, setShowModal] = useState(false)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [maskedPANNumber, setMaskedPANNumber] = useState("")
  const [alreadyCkycVerified, setAlreadyCkycVerified] = useState(false)
  const [ckycObj, setCkycObj] = useState()
  const [showError, setShowError] = useState({})
  const [checkboxValue, setCheckboxValue] = useState(false)
  const [errorstate, setErrorState] = useState({
    pannoMask: "Please enter Aadhar Number",
  })
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
    setValue
  } = useForm()
  const [captchaText, setCaptchaText] = useState('');
  const [userCaptchaValue, setUserCaptchaValue] = useState('');
	const [captchaError, setCaptchaError] = useState('');
  const canvasRef = useRef(null);
  const [isCaptchaVerified,setIsCaptchaVerified] = useState(false)
  const [authTypeSelected, setAuthTypeSelected] = useState("MOBILE");
  const [transactionStatus, setTransactionStatus] = useState("")
  const [transactionID, setTransactionID] = useState("")
  const [ckycTransactionID, setCkycTransactionID] = useState("")
  const [isOtpTriggered,setIsOtpTriggered] = useState(false)
  const [otpEntered,setOtpEntered] = useState("")
  const [otpError, setOtpError] = useState("")
  const [timer, setTimer] = useState(0)
  const [isResendVisible, setIsResendVisible] = useState(false)

  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    let payload = {
      // "journeyId":"60af3842ea22f32efbf53d4a"
      journeyId: journeyState.journeyId,
    }
    dedupeCall(payload).then(res => {
      console.log(res, "dedupe call")
    })
  }, [])
  
  useEffect(async () => {
    let payload = {
      journeyId: journeyState.journeyId,
      allRowData: true,
    }
    let journeyResult = await fetchAllJourneyData(payload)
    const selected_ageProof = journeyResult?.lifeAssuredDetails?.proofOfIdentity
    if(lookup.NSAP_AGE_PROOF[0].hasOwnProperty(selected_ageProof) || ["EQUITAS","equitas","36"].includes(journeyResult?.basicDetails?.channel)){
       handleSkip()
       return;
    }
    if(journeyResult?.lifeAssuredDetails?.ckycVerified === true){
      props.setCurrentSectionIndex(prev => prev + 1)
      let panNumber = journeyResult.lifeAssuredDetails?.ckycDetails?.CKYCPAN
      let maskedPan = `******${panNumber.slice(-4)}`
      console.log(maskedPan)
      setMaskedPANNumber(maskedPan?.toUpperCase())
      setAlreadyCkycVerified(true)
    }else if(journeyResult?.lifeAssuredDetails?.ckycVerified === false){
      if(journeyResult?.lifeAssuredDetails?.panEntered){
        setCkycObj(oldItem => {
          return {
            ...oldItem,
            ["pannoMask"]: journeyResult?.lifeAssuredDetails?.panEntered
            ? `******${(journeyResult.lifeAssuredDetails.panEntered.toUpperCase()).slice(-4)}`
            : "",
            ["panno"]: journeyResult?.lifeAssuredDetails?.panEntered?.toUpperCase(),
          }
        })
      }
    }
  }, [])

  useEffect(() => {
    if(alreadyCkycVerified){
      props.setCurrentSectionIndex(prev => prev + 1) // this moves to previous section on same page
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex + 1,
          lastPageCode: props.pageId,
          lastSectionCode:
            props.sections[props.currentSectionIndex + 1].sectionId,
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex + 1].sectionId
          ),
        }
      })
      return 
    }
  },[alreadyCkycVerified])

  const getRandomVal = () => Math.random() // NOSONAR

  const generateRandomChar = (min, max) =>
    String.fromCharCode(Math.floor
      (getRandomVal() * (max - min + 1) + min)); 

  const generateCaptchaText = () => {
    let captcha = '';
    for (let i = 0; i < 3; i++) {
      captcha += generateRandomChar(65, 90);  // Upper case alphabets
      // captcha += generateRandomChar(97, 122); // lower case alphabets
      captcha += generateRandomChar(48, 57);  // digits
    }
    const captchatext = captcha.split('').sort(() => getRandomVal() - 0.5).join('');
    return captchatext;
  };

  const drawCaptchaOnCanvas = (ctx, captcha) => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    const textColors = ['rgb(0,0,0)', 'rgb(130,130,130)'];
    const letterSpace = 150 / captcha.length;
    for (let i = 0; i < captcha.length; i++) {
      const xInitialSpace = 25;
      ctx.font = '25px Arial';
      ctx.fillStyle = textColors[Math.floor(getRandomVal() * 2)];
      ctx.fillText(captcha[i],xInitialSpace + i * letterSpace, Math.floor(getRandomVal() * 16 + 20), 100);
    }
  };

  const initializeCaptcha = (ctx) => {
    setUserCaptchaValue('');
    const newCaptcha = generateCaptchaText();
    setCaptchaText(newCaptcha);
    drawCaptchaOnCanvas(ctx, newCaptcha);
  };

  const handleCaptchaChange = (e) => {
		setCaptchaError('')
    if (e.target.value.length <= 6) {
      setUserCaptchaValue(e.target.value);
      if (e.target.value === captchaText){
        setIsCaptchaVerified(true)
      }else{
        setIsCaptchaVerified(false)
        setIsOtpTriggered(false)
        setOtpEntered("")
      }
    }
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    initializeCaptcha(ctx);
  }, []);

  const changeInput = ({ target }) => {
    console.log(target, "fdfgrgrfgr1")
    if (target.name === "panno") {
      setCkycObj(oldItem => {
          return {
            ...oldItem,
            [target.name]: target.value?.toUpperCase(),
            ["pannoMask"]: target.value?.toUpperCase(),
          }
        })
    }
    validate(target)
  }

  const validate = target => {
    if(target.value){
        let regex = "/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/"
        let rg = regex.substring(1, regex.lastIndexOf('/'))
        let flags = regex.substring(regex.lastIndexOf('/') + 1)
        let regex_exp = new RegExp(rg, flags)
        if (!regex_exp.test(target.value)) {
          setErrorState(prev => {
            return {
              ...prev,
              [target.name]: "PAN should be in AAAAA1111A format",
            }
          })
        }else{
        setErrorState(prev => {
          return {
            ...prev,
            [target.name]: "",
          }
        })
        setShowError(true)
      }
      setShowError(true)
    }
  }
  
  const changeInputToMask = ({ target }, name) => {
    console.log(target)
   if(name === "Mask"){ 
    if(target.value && !errorstate["panno"]){
      let mask = `******${target.value.slice(-4)}`
      setCkycObj(oldItem => {
        return {
          ...oldItem,
          ["pannoMask"]: mask,
        }
      })
      }
    }else {
      let nonMask = ckycObj?.panno || target.value
      setCkycObj(oldItem => {
        return {
          ...oldItem,
          ["pannoMask"]: nonMask?.toUpperCase(),
        }
      })
    }
  }

  const submitPanVerfication = data => {
    // let journeyFormatData = props.applicationDataInJourneyFormat()
    // DataLayerIntegration(journeyFormatData, "proceed", props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    try {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      if(userCaptchaValue !== captchaText) {
        if(userCaptchaValue == '') {
          setCaptchaError("This field is Required.");
          return;
        }
        setCaptchaError("Invalid Captcha value.")
        initializeCaptcha(ctx);
        return;
      }
      initializeCaptcha(ctx);
    }catch(err){
      console.log("error in captcha", err)
    }

    if (!ckycObj?.panno) {
      setErrorState(prev => {
        return {
          ...prev,
          panno: "Please enter PAN Number",
        }
      })
      return; 
    }else{
      setErrorState(prev => {
        return {
          ...prev,
          panno: "",
        }
      })
    }

    try {
      if (journeyState.applicationNo) {
        executeRecaptcha("submit_form")
          .then(token => {
            verifyCaptcha({
              token: token,
              applicationNumber: journeyState.applicationNo,
              sectionId: "ckycSection",
              pageId: "BIPage",
            })
              .then(res => {
                console.info(res)
              })
              .catch(err => {
                console.info(err)
              })
          })
          .catch(err => {
            console.info(err)
          })
      }

      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "PAN verification ", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in submitPanVerfication:", error);
    }
    if(alreadyCkycVerified){
      props.setCurrentSectionIndex(prev => prev + 1) // this moves to previous section on same page
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex + 1,
          lastPageCode: props.pageId,
          lastSectionCode:
            props.sections[props.currentSectionIndex + 1].sectionId,
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex + 1].sectionId
          ),
        }
      })
      return 
    }
    let dobKey 
    if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
      dobKey = "calculatePremiumPage.CPPersonalDetailsSection.dob"
    }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
      dobKey = "PageISelect360CalculatePremium.CPPersonalDetailsSection.dob"
    }else if(journeyState.journeyIdFromStrapi === "youngTermPlanJourney"){
      dobKey = "PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.dob"
    }else if(journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney"){
      dobKey = "PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingPersonaldetails.dob"
    }

    const epochDate = conditionState[dobKey]
    const date = moment.unix(epochDate).utcOffset("+05:30").format("DD-MM-YYYY");
    const ckycData = {
      journeyId: journeyState.journeyId,
      applicationNo: journeyState.applicationNo,
      payload: {
        Documents: [
          {
            InputIdType: "C",
            InputIdNo: ckycObj.panno,
            DateOfBirth: date,
          }
        ],
      },
    }
    cKycSearch(ckycData)
      .then(res => {
        console.log(res);
        successToastr("CKYC verification is successfull");
        let sendPayload = {
          applicationData:  journeyState.journeyData,
          journeyData: {
            _id: journeyState.journeyId,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            applicationNo: journeyState.applicationNo,
            illustrationNumber: journeyState.illustrationNumber,
            proposalEntryId: journeyState.proposalEntryId,
            lastPageCode: props.pageId,
            planOption: journeyState.planOption,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          },
        }
        setTimeout(() => {
          saveApplication(sendPayload).then(res => {
            console.log(res, "application response");
            // condition of same page
            props.setCurrentSectionIndex(prev => prev + 1) // this moves to previous section on same page
            setJourneyState(prev => {
              return {
                ...prev,
                lastPage: props.currentPageIndex,
                lastSection: props.currentSectionIndex + 1,
                lastPageCode: props.pageId,
                lastSectionCode:
                  props.sections[props.currentSectionIndex +1].sectionId,
                journeyCode: findCurrentJourneyCode(
                  props.pageId,
                  props.sections[props.currentSectionIndex + 1].sectionId
                ),
              }
            })
            clearToastr();
          })
        }, 2500);
      })
      .catch(error => {
        errorToastr("Details not found. CKYC verification is Unsuccessful");
        console.log("error >>",error);
      })
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "proceed", props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
  }

  const handleSkip = () => {

    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Skip", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
        if (journeyState.applicationNo) {
          executeRecaptcha("submit_form")
            .then(token => {
              verifyCaptcha({
                token: token,
                applicationNumber: journeyState.applicationNo,
                sectionId: "ckycSection",
                pageId: "BIPage",
              })
                .then(res => {
                  console.info(res)
                })
                .catch(err => {
                  console.info(err)
                })
            })
            .catch(err => {
              console.info(err)
            })
        }
    } catch (error) {
      console.error("Error in handleSkip:", error);
    }
    // let e =""
    // // getAllJourneyData(e)
    // let journeyFormatData = props.applicationDataInJourneyFormat()
    // DataLayerIntegration(journeyFormatData, e, props.sections?.[props.currentSectionIndex]?.sectionId, "skip", journeyState)
    if(alreadyCkycVerified){
      props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex + 1,
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex + 1].sectionId,
          journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex + 1].sectionId)
        }
      })
      return
    }else{
      let sendPayload = {
        applicationData:  journeyState.journeyData,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex + 1,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          ckycSkip: true,
          planOption: journeyState.planOption,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        },
      }
      saveApplication(sendPayload).then(res => {
        console.log(res, "application response")
        // condition of same page
        props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
  
        setJourneyState(prev => {
          return {
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex + 1,
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex + 1].sectionId,
            journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex + 1].sectionId)
          }
        })
      }).catch(err => {
        console.log(err, "err in saveApplication ckyc")
      })
    }
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "skip", journeyState)
    

  }
//   const getAllJourneyData = async (e) =>{
//     let apiUrl = process.env.GATASBY_API_URL
//     try{
//       let alljounreyData = await axios.get(`${apiUrl}/all-jounrey-data-internal/${journeyState.journeyId}`)
//       DataLayerIntegration(alljounreyData, e, props.sections?.[props.currentSectionIndex]?.sectionId,"skip")
//     }
//     catch(err){
//       console.log("err in section change",err)
//     }
//  }

  // code of tab enter
  const handleEnterSkip = (event) =>{
    if(event?.key == 'Enter'){
      handleSkip();
    }
  }

  const sendCkycOtp = (type) => {
    setAuthTypeSelected(type)

    let dobKey 
    if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
      dobKey = "PageISelect360CalculatePremium.CPPersonalDetailsSection.dob"
    }else if(journeyState.journeyIdFromStrapi === "youngTermPlanJourney"){
      dobKey = "PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.dob"
    }

    const epochDate = conditionState[dobKey]
    const date = moment.unix(epochDate).utcOffset("+05:30").format("DD-MM-YYYY");
    const ckycData = {
      journeyId: journeyState.journeyId,
      applicationNo: journeyState.applicationNo,
      module :"LA",
      payload: {
        Documents: [
          {
            InputIdType: "C",
            InputIdNo: ckycObj.panno,
            DateOfBirth: date,
          }
        ],
      },
    }

    ckycSearchV2(ckycData)
    .then(res => {
       if (res.status){
        successToastr("OTP sent successfully")
        setIsOtpTriggered(true)
        setTransactionStatus(res?.data?.transactionStatus || "");
        setTransactionID(res?.data?.transactionID || "");
        setCkycTransactionID(res?.data?.ckycTransactionID || "");
        setTimer(30)
        setIsResendVisible(false)
       }
    })
    .catch(err => {
      errorToastr(err?.response?.data?.message || "Failed to send OTP, Please try again")
      setIsOtpTriggered(false)
    })
  }

  useEffect(() => {
    if (timer === 0) {
      setIsResendVisible(true)
      return
    }
    const countdown = setInterval(() => {
      setTimer(prev => prev - 1)
    }, 1000)
    return () => clearInterval(countdown)
  }, [timer])

  const verifyCkycOtp = (e) => {
    if(e && e.preventDefault) e.preventDefault();

    if (!checkboxValue) {
      setErrorState(prev => {
        return {
          ...prev,
          ckycTermChecked: "Please select the declaration",
        }
      })
      return;
    } else {
      setErrorState(prev => {
        return {
          ...prev,
          ckycTermChecked: "",
        }
      })
    }

    if (!ckycObj?.panno) {
      setErrorState(prev => {
        return {
          ...prev,
          panno: "Please enter PAN Number",
        }
      })
      return;
    }else{
      setErrorState(prev => {
        return {
          ...prev,
          panno: "",
        }
      })
    }

    try {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      if(userCaptchaValue !== captchaText) {
        if(userCaptchaValue == '') {
          setCaptchaError("This field is Required.");
          return;
        }
        setCaptchaError("Invalid Captcha value.")
        initializeCaptcha(ctx);
        return;
      }
    }catch(err){
      console.log("error in captcha", err)
    }

    if (!isOtpTriggered){
      errorToastr("Please authenticate via OTP to proceed")
      return;
    }

    if (!otpEntered || otpEntered.length !== 6){
      setOtpError("Otp required or invalid otp")
      return;
    }else{
      setOtpError("")
    }

    let dobKey 
    if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
      dobKey = "PageISelect360CalculatePremium.CPPersonalDetailsSection.dob"
    }else if(journeyState.journeyIdFromStrapi === "youngTermPlanJourney"){
      dobKey = "PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.dob"
    }

    const epochDate = conditionState[dobKey]
    const date = moment.unix(epochDate).utcOffset("+05:30").format("DD-MM-YYYY");

    const ckycDownloadData = {
      journeyId: journeyState.journeyId,
      applicationNo: journeyState.applicationNo,
      module :"LA",
      payload: {
        Documents: [
          {
            InputIdType: "C",
            InputIdNo: ckycObj.panno,
            DateOfBirth: date,
          },
        ],
        otp : otpEntered,
        ckycTransactionId: ckycTransactionID,
        transactionID:transactionID,
        transactionStatus:transactionStatus
      },
    }
    
    ckycDownloadV2(ckycDownloadData)
    .then(res => {
      successToastr("OTP verified successfully")
      let sendPayload = {
        applicationData:  journeyState.journeyData,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          planOption: journeyState.planOption,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        },
      }
      setTimeout(() => {
        saveApplication(sendPayload).then(res => {
          props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
          setJourneyState(prev => {
            return {
              ...prev,
              lastPage: props.currentPageIndex,
              lastSection: props.currentSectionIndex + 1,
              lastPageCode: props.pageId,
              lastSectionCode:
                props.sections[props.currentSectionIndex +1].sectionId,
              journeyCode: findCurrentJourneyCode(
                props.pageId,
                props.sections[props.currentSectionIndex + 1].sectionId
              ),
            }
          })
          clearToastr();
        })
      }, 2500);
    })
    .catch(err => {
      errorToastr(err?.response?.data?.message || "OTP Verification Failed, Please try again")
     
    })
  } 

  return (
    <>
      <style>
        {`
            .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
                margin-left:-2px;
            }
            ::-ms-clear {
                display: none;
            }
            #more {
                display: none;
            }
            .text-danger{
                font-size:15px;
            }
            .previous-btn,.previous-btn:hover{
              padding:0 !important;
              
            }
            .previous-btn{
              margin-left:5px
            }
            .ekycleftsidebar .col-md-9.brd-right{
              width:100% !important;
            }
            @media (max-width: 992px){
              .ekyc-list li{
                width: 100%;
                display: flex;
                align-items: center;
              }
              .ekyc-list li svg{
                width: 3rem;
              }
              .checkbox1 label{
                font-size: 16px !important;
              }
              .ekycleftsidebar{
                width: 100%;
              }
              .right-box-design-size{
                width: 100%;
              }
              .iselect-mg-bottom.ekyc-input .col-xs-12{
                width:100% !important;
              }
              .iselect-mg-bottom.ekyc-input .form-group input{
               width:100% !important;
              }
              .previous-btn a{
                display:inline-block;
              }
              //display none
              .otp-mobile-view-structure.otpscreen{
                 display:none !important;
              }
              //display none
              .mobile-view-btn-Q1{
                display:none !important; 
              }
            }
        `}
      </style>

      {/* <!--body Section--> */}
      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            {/* <!--left-side--> */}
            <div className="col-md-9 ekycleftsidebar">
            <form
              id="OTPverify"
              name="calculatePremium"
              onSubmit={(e) => verifyCkycOtp(e)}
            >
              <div className="col-md-9 brd-right">
                <div className="iselect-box-design">
                  <div className="heading-design">
                    <div className="iselect-padding left-side-head ckyc-w">
                      <h1 className="iselect-heading">
                        Provide below details for verification
                      </h1>
                    </div>
                    <div className="app-quatation nri-mt-space hidden-desktop-screen">
                      <div className="application-design-number">
                        Application Number: {journeyState.applicationNo}
                      </div>
                    </div>
                  </div>
                  <div className="iselect-padding">
                    <div className="iselect-mg-bottom ekyc-input">
                      <div className="col-md-6 col-xs-12 all-box-padding-right">
                        <p>
                          <strong>Enter your PAN for CKYC Verification</strong>
                        </p>
                        <div className="form-group">
                          <label className="title-bg inp-label">Enter PAN</label>
                            <input
                              className={`form-control ${
                                errors.panno && "invalid"
                              }`}
                              style={ isIE ? {lineHeight: 1} : {} }
                              type="text"
                              id="panno"
                              autoComplete="new-password"
                              disabled={alreadyCkycVerified}
                              placeholder="Enter PAN Number"
                              name="panno"
                              value={ckycObj?.pannoMask}
                              onChange={changeInput}
                              onClick={(event) => {changeInputToMask(event, "nonMask")}}
                              onBlur={(event) => {changeInputToMask(event, "Mask")}}
                            />
                          {errorstate.panno && (
                            <label className="error input-error2">
                              {errorstate.panno}
                            </label>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="captcha-container">
                      <div className="captcha-header">
                        <label className="captcha-label" htmlFor="captcha">Refresh Captcha</label>
                        <button
                          className="reload-button"
                          onClick={(e) => {
                            e.preventDefault();
                            initializeCaptcha(canvasRef.current.getContext('2d'));
                          }}
                        >
                          <img src={reloadSrc} alt="Reload" className="reload-icon" />
                        </button>
                      </div>
                      <div className="captcha-input-container">
                        <canvas
                          ref={canvasRef}
                          className="captcha-canvas"
                          width={"200"}
                          height={"40"}
                        />
                        <input
                          name="captcha"
                          className="input-meet-advisor"
                          type="text"
                          placeholder="Enter Captcha"
                          onChange={handleCaptchaChange}
                          value={userCaptchaValue}
                        />
                      </div>
                      {captchaError && <div className="error-message-input">{captchaError}</div>}
                    </div>
                    {isCaptchaVerified && ckycObj?.panno?.length === 10 && !errorstate.panno && <div style={{ marginTop: "40px" }}>
                      <p style={{margin : "0px"}}><strong>Please authenticate your identity through One Time Password ( OTP )</strong></p>
                      {!isOtpTriggered && <div className="otp-container">
                        <button
                          type="button"
                          className={`otp-button ${authTypeSelected === "MOBILE" ? "active" : ""}`}
                          onClick={() => sendCkycOtp("MOBILE")}
                          style={journeyState.channel === "A" ? { backgroundColor: "#3e505d" } : (journeyState.channel === "C" ? {backgroundColor: "#03a9f4" } : {backgroundColor : "#eb7f25"})}
                        >
                          Send OTP to registered mobile number
                        </button>
                      </div>}
                      {isOtpTriggered && (
                          <div className="col-md-6 col-xs-12 mb-20" style={{ marginTop: "15px", marginBottom : "30px" }}>
                            <div className="form-group">
                              <label className="title-bg inp-label ">
                                Enter One Time Password (OTP)
                              </label>
                              <input
                                className={`form-control ${errors.authCode && "invalid"
                                  }`}
                                style={isIE ? { lineHeight: 1 } : {}}
                                type="text"
                                placeholder="ENTER HERE"
                                autoComplete="new-password"
                                name="authCode"
                                value={otpEntered}
                                onChange={(e)=> {
                                  if (isNaN(e.target.value)){
                                    return;
                                  }
                                  if (e.target.value.includes(".")){
                                    return;
                                  }
                                  if(e.target.value.length <= 6){
                                    setOtpError("")
                                  }else{
                                    setOtpError("OTP should be 6 digits")
                                  }
                                  setOtpEntered(e.target.value)
                                }}
                                maxLength={6}
                              />
                              {otpError && (
                                <label className="error input-error">
                                  {otpError}
                                </label>
                              )}
                              {isResendVisible ? (
                                <div className="provider resend-otp eky-resend" id="resend" style={{ cursor: "pointer" }} tabIndex="0" onKeyPress={() => sendCkycOtp("MOBILE")}>
                                  <a id="resend" aria-hidden="true" onClick={() => sendCkycOtp("MOBILE")}>
                                    Resend OTP
                                  </a>{" "}
                                  <span className="fa fa-angle-right"></span>
                                </div>
                              ) : (
                                <div className="resend-otp eky-resend">
                                  <span className="fa">
                                    Resend OTP in {timer} seconds
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>

                      )}
                    </div>}
                    <div className="iselect-mg-bottom check-design">
                      <div className="col-md-12 col-xs-12">
                        <div className="transactionDetailsWrap del-agree">
                          <div className="detailContentWrap">
                            <div className="row iAgree">
                              <div className="form-group">
                                <div className="inner-addon left-addon" >
                                  <div className="checkbox1" style={{marginTop : "20px"}}>
                                      <input
                                        id="checkboxG7"
                                        type="checkbox"
                                        className={`css-checkbox form-control ${
                                          errorstate.ckycTermChecked &&
                                          "invalid"
                                        }`}
                                        checked={checkboxValue}
                                        onChange={(e) => {
                                          setCheckboxValue(e.target.checked);
                                          if (e.target.checked) {
                                            setErrorState(prev => ({...prev, ckycTermChecked: ""}))
                                          } else {
                                            setErrorState(prev => ({...prev, ckycTermChecked: "Please select the declaration"}))
                                          }
                                        }}
                                      />
                                      <label
                                        htmlFor="checkboxG7"
                                        className="css-label"
                                      >
                                        {" "}
                                        I hereby authorize Canara HSBC Life
                                        Insurance to fetch my KYC details using my
                                        PAN card for taking this policy.{" "}
                                      </label>
                                      {errorstate.ckycTermChecked && (
                                        <span className="input-error" style={{fontSize:'13px',marginLeft:'5.2rem'}}>
                                          {
                                            errorstate.ckycTermChecked
                                          }
                                        </span>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="iselect-mg-bottom pd-bt40"></div>
                    <div className="iselect-mg-bottom hidden-desktop-screen">
                      <div className="col-md-12">
                        <div className="but-center text-right">
                          <div className="provider submit-btn cen" tabIndex="0"
                            onKeyPress={(e)=>handleEnterSkip(e)}>
                            {" "}
                            <a
                            aria-hidden="true"
                              onClick={handleSkip}
                              style={{ padding: "14px 56px" }}
                            >
                              {" "}
                              Skip{" "}
                            </a>{" "}
                          </div>
                          <div className="previous-btn cen">
                            <a style={{padding:"0px"}}>
                              {" "}
                              <button
                                type="submit"
                                value="otpsubmit"
                                style={{
                                  backgroundColor: "transparent",
                                  padding: "14px 40px",
                                  borderRadius:"10px",
                                  border: "none",
                                  color: "#fff",
                                }}
                              >
                                Proceed
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!--mobile view otp screen--> 
              <div
                className={`otp-mobile-view-structure otpscreen ${
                  showModal ? "" : "hidden"
                }`}
                style={{ zIndex: "999" }}
              >
                <div className="generate-otp-structure">
                  <div className="mobile-otp-icon">
                    <img src="images/mobile-otp.png" />
                  </div>

                  <div className="iselect-mg-bottom">
                    <div className="col-md-12 col-xs-12 iselect-smoke ekyc-otp">
                      <div className="col-md-6 col-xs-12">
                        <div className="smoke-design smoke ekyc-box">
                          <div className="smoke-white-clr active smoke1 s1">
                            <p>Send OTP to registered mobile number</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-xs-12">
                        <div className="smoke-design2 smoke">
                          <div className="smoke-white-clr smoke2 s2">
                            <p>Send OTP to registered Email ID</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <p className="sent-otp">
                    {" "}
                    OTP has been sent to your registered Email ID
                  </p>
                </div>
                <div className="clearfix"></div>
                <div className="iselect-mg-bottom mt-30 enter-otp-structure">
                  <div className="col-md-6 col-xs-12 all-box-padding-right">
                    <div className="form-group">
                      <label className="title-bg">Enter OTP</label>
                      <input
                        className="form-control"
                        style={{lineHeight: isIE? '1!important': ''}}
                        autoComplete="new-password"
                        name="otp"
                        type="text"
                        placeholder="XXXXXX"
                      />
                      <div className="resend-otp">
                        <a>Resend OTP</a>{" "}
                        <span className="fa fa-angle-right"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              */}
              {/* <!--mobile view otp screen--> */}
            </form>
            </div>
            {/* <!--left-side--> */}
            {/* <!--right-side--> */}
            <div className="col-md-3 right-box-design-size mg-ckyc-top">
              <div className="ekyc-design-right">
                <h2>Avail below benefits by providing these details-</h2>
                <ul className="ekyc-list">
            <li>
            <svg  className="image-color image-color--width" version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="186.000000pt" height="198.000000pt" viewBox="0 0 186.000000 198.000000"
                preserveAspectRatio="xMidYMid meet">
                <metadata>
                Created by potrace 1.10, written by Peter Selinger 2001-2011
                </metadata>
                <g transform="translate(0.000000,198.000000) scale(0.100000,-0.100000)"
                 stroke="none">
                <path d="M890 1856 c-47 -31 -57 -44 -71 -96 -11 -40 -10 -50 10 -89 11 -25
                21 -49 21 -53 0 -5 -87 -8 -194 -7 -176 2 -196 0 -219 -17 -15 -10 -27 -26
                -27 -34 -1 -26 -2 -794 -1 -817 1 -27 26 -31 36 -5 3 9 6 188 5 398 -1 467
                -15 427 154 432 100 3 117 1 122 -13 4 -9 3 -19 -1 -23 -4 -4 -51 -7 -105 -7
                -68 0 -103 -4 -112 -13 -10 -10 -14 -95 -16 -380 -2 -202 0 -377 3 -389 8 -35
                33 -28 40 10 4 19 5 188 2 375 -3 246 -1 344 7 351 6 5 45 8 86 7 71 -1 75 -2
                78 -25 2 -13 14 -32 25 -42 20 -16 45 -18 245 -19 l222 0 20 33 c11 17 21 36
                23 41 5 14 145 17 154 3 5 -7 8 -93 8 -192 l0 -180 28 -3 27 -3 0 199 c0 171
                -2 201 -16 213 -11 9 -48 13 -118 14 -97 0 -101 1 -104 23 -3 22 -2 22 103 22
                75 0 114 -4 135 -15 l30 -16 0 -664 c0 -493 -3 -666 -12 -671 -20 -12 -92 -15
                -540 -20 l-437 -6 -26 26 c-20 20 -25 35 -25 74 0 35 5 52 15 55 18 8 27 -7
                31 -51 1 -19 8 -40 14 -46 8 -8 125 -11 397 -11 l385 0 84 88 84 88 0 320 0
                320 -27 -3 -28 -3 4 -295 c4 -332 5 -328 -62 -309 -28 8 -43 6 -66 -6 -29 -14
                -30 -18 -33 -88 l-3 -72 -355 0 -355 0 0 35 0 35 75 5 c41 3 82 10 90 15 8 5
                76 8 151 6 150 -3 195 5 267 48 60 35 68 68 24 100 -17 12 -34 21 -38 21 -4 0
                -16 8 -27 17 -16 16 -43 18 -193 20 -113 1 -180 5 -188 12 -9 8 -72 12 -180
                12 -140 0 -166 3 -166 15 0 12 17 15 96 12 85 -3 97 -1 110 16 31 43 2 68 -41
                34 -25 -19 -28 -19 -75 -4 -27 9 -59 16 -73 16 -24 0 -69 -41 -80 -72 -4 -10
                -14 -18 -24 -18 -10 0 -31 -14 -47 -30 -16 -17 -37 -30 -47 -30 -19 0 -49 -41
                -49 -67 1 -24 20 -49 45 -56 11 -4 35 -20 53 -37 18 -16 41 -30 50 -31 9 0 44
                -1 77 -2 l60 -2 0 -75 c0 -64 3 -78 23 -98 l22 -22 521 -1 c545 0 537 -1 560
                43 13 25 13 1362 0 1387 -23 41 -33 43 -236 42 -188 -2 -195 -1 -195 18 0 11
                6 26 14 34 14 14 21 49 18 95 -1 13 -24 45 -52 72 -47 48 -52 50 -102 49 -38
                0 -63 -7 -88 -23z m159 -61 c21 -20 26 -35 26 -74 0 -33 -6 -55 -17 -68 -38
                -42 -5 -102 57 -103 40 -1 77 -33 73 -62 l-3 -23 -210 0 c-208 0 -210 0 -213
                22 -4 29 31 63 67 63 31 0 81 40 81 65 0 9 -11 28 -25 43 -46 49 -23 133 45
                161 37 16 91 5 119 -24z m-401 -1264 c14 -7 17 -21 15 -67 -1 -31 -6 -61 -11
                -66 -4 -4 -94 -7 -198 -6 l-189 3 -3 59 c-2 32 -1 65 2 72 4 11 43 14 186 14
                100 0 189 -4 198 -9z m350 -33 c7 -7 12 -21 12 -32 0 -45 -11 -49 -146 -50
                -71 -1 -135 2 -141 7 -14 10 -18 69 -6 80 12 13 268 8 281 -5z m92 -13 c18
                -21 5 -45 -25 -45 -20 0 -25 5 -25 23 0 39 26 50 50 22z m-882 -23 c2 -7 -3
                -12 -12 -12 -9 0 -16 7 -16 16 0 17 22 14 28 -4z m1155 -89 c11 -10 -34 -53
                -55 -53 -21 0 -24 30 -6 48 13 13 50 16 61 5z"/>
                <path d="M925 1764 c-32 -34 -31 -52 3 -91 33 -39 55 -41 88 -10 31 29 32 76
                1 105 -31 29 -63 28 -92 -4z m80 -45 c0 -8 -12 -15 -27 -17 -24 -3 -28 0 -28
                21 0 13 3 27 7 30 9 10 48 -18 48 -34z"/>
                <path d="M690 1210 c-15 -15 -20 -33 -20 -78 0 -76 16 -92 91 -92 50 0 58 3
                77 30 31 41 29 97 -3 133 -22 22 -34 27 -75 27 -37 0 -55 -5 -70 -20z m105
                -75 c0 -27 -3 -30 -37 -33 -30 -3 -38 1 -43 18 -10 30 12 52 49 48 27 -3 31
                -7 31 -33z"/>
                <path d="M958 1099 c-5 -3 -8 -19 -6 -35 l3 -29 150 2 c83 1 156 2 163 3 7 0
                12 13 12 30 0 17 -5 30 -12 30 -103 5 -302 4 -310 -1z"/>
                <path d="M686 898 c-20 -28 -21 -117 -2 -144 11 -15 27 -19 74 -19 52 0 63 3
                81 25 29 35 28 99 -2 133 -20 23 -30 27 -79 27 -47 0 -59 -4 -72 -22z m112
                -67 c6 -38 -36 -54 -72 -28 -13 10 -16 20 -11 36 6 18 13 22 43 19 30 -2 38
                -7 40 -27z"/>
                <path d="M954 786 c-3 -8 -4 -23 -2 -33 3 -16 17 -18 163 -18 l160 0 0 30 0
                30 -158 3 c-131 2 -158 0 -163 -12z"/>
                </g>
              </svg>
              
              <span>Faster form filling</span>
            </li>
            <li>
            <svg className="image-color" version="1.0" xmlns="http://www.w3.org/2000/svg"
              width="186.000000pt" height="201.000000pt" viewBox="0 0 186.000000 201.000000"
              preserveAspectRatio="xMidYMid meet">
              <metadata>
              Created by potrace 1.10, written by Peter Selinger 2001-2011
              </metadata>
              <g transform="translate(0.000000,201.000000) scale(0.100000,-0.100000)"
               stroke="none">
              <path d="M260 1040 l0 -720 370 0 369 0 18 -27 c10 -14 37 -47 60 -72 24 -25
              49 -54 56 -64 10 -15 31 -18 147 -20 120 -2 138 0 165 18 52 35 94 77 130 131
              34 51 35 55 35 151 0 75 -4 107 -18 134 -32 63 -61 96 -112 129 l-50 32 0 514
              0 514 -585 0 -585 0 0 -720z m1098 656 c5 -3 8 -215 8 -473 l-1 -468 -75 0
              c-59 0 -84 -5 -119 -23 -96 -51 -150 -110 -166 -182 -4 -19 -12 -41 -18 -48
              -6 -7 -7 -35 -3 -67 l6 -55 -332 2 -333 3 -2 650 c-1 357 2 654 7 660 8 10
              1012 11 1028 1z m21 -1011 c61 -16 87 -38 136 -111 33 -49 35 -58 35 -132 0
              -73 -2 -82 -32 -123 -59 -83 -90 -107 -165 -124 -117 -27 -219 23 -288 142
              -29 49 -34 131 -10 177 8 15 15 34 15 41 0 8 25 39 56 69 39 40 63 56 82 56
              15 0 34 5 42 10 21 14 66 12 129 -5z"/>
              <path d="M547 1534 c-12 -15 -28 -32 -34 -40 -24 -24 -15 -69 22 -107 19 -20
              35 -38 35 -41 0 -3 -18 -17 -40 -31 -43 -27 -65 -55 -75 -97 -5 -21 -3 -27 14
              -33 26 -8 61 11 61 34 0 29 46 65 85 65 38 0 82 -33 87 -67 4 -29 33 -45 56
              -31 33 21 25 44 -37 104 -34 33 -61 63 -61 68 0 5 11 14 24 20 28 12 43 64 32
              108 -18 72 -123 102 -169 48z m109 -59 c24 -37 3 -75 -41 -75 -38 0 -55 16
              -55 52 0 50 68 66 96 23z"/>
              <path d="M467 1072 c-7 -9 -8 -19 -1 -28 14 -23 744 -23 759 0 22 36 -3 38
              -380 40 -295 1 -369 -2 -378 -12z"/>
              <path d="M468 913 c-5 -7 -7 -21 -3 -33 6 -20 12 -20 381 -20 338 0 375 2 381
              16 16 44 7 45 -380 47 -277 1 -371 -1 -379 -10z"/>
              <path d="M467 742 c-20 -43 -5 -45 275 -43 253 1 278 4 278 31 0 29 -22 31
              -280 33 l-263 2 -10 -23z"/>
              <path d="M1388 543 c-29 -26 -64 -61 -78 -78 -70 -82 -68 -80 -91 -59 -12 10
              -25 29 -30 42 -12 31 -53 27 -57 -5 -4 -25 63 -120 90 -129 19 -6 58 11 58 26
              0 6 42 52 94 104 75 74 93 99 89 115 -9 36 -21 34 -75 -16z"/>
              </g>
            </svg>
            <span>KYC document waive off</span>
            </li>
            <li>
            <svg className="image-color" version="1.0" xmlns="http://www.w3.org/2000/svg"
              width="186.000000pt" height="198.000000pt" viewBox="0 0 186.000000 198.000000"
              preserveAspectRatio="xMidYMid meet">
              <metadata>
              Created by potrace 1.10, written by Peter Selinger 2001-2011
              </metadata>
              <g transform="translate(0.000000,198.000000) scale(0.100000,-0.100000)"
               stroke="none">
              <path d="M531 1624 c-19 -9 -48 -30 -63 -47 -59 -66 -58 -55 -60 -522 l-3
              -430 -70 -3 c-99 -4 -105 -12 -105 -129 0 -109 13 -140 80 -186 22 -15 65 -17
              458 -17 489 0 455 -5 527 79 19 22 20 41 25 465 l5 441 129 1 c157 0 156 -1
              156 124 0 117 -33 180 -116 222 -46 23 -912 25 -963 2z m772 -51 c4 -3 1 -13
              -7 -22 -31 -36 -34 -91 -35 -600 -1 -283 -4 -524 -7 -535 -12 -39 -54 -66
              -102 -66 -38 0 -49 5 -78 37 -33 36 -34 39 -34 125 0 76 -2 89 -19 98 -12 6
              -121 10 -285 10 l-266 0 0 438 0 439 23 26 c49 57 51 57 443 57 198 0 364 -3
              367 -7z m182 -13 c49 -30 67 -73 63 -150 l-3 -65 -115 0 -115 0 4 80 c3 85 13
              106 58 136 36 24 68 24 108 -1z m-505 -1057 c0 -43 7 -69 25 -102 14 -23 25
              -45 25 -47 0 -2 -155 -4 -345 -4 l-344 0 -26 25 c-22 23 -25 34 -25 99 0 40 3
              76 7 79 3 4 159 7 345 7 l338 0 0 -57z"/>
              <path d="M770 1461 c-63 -21 -120 -54 -126 -74 -10 -31 -11 -246 -2 -283 5
              -17 18 -36 31 -42 12 -7 54 -34 92 -62 39 -27 76 -50 83 -50 7 0 36 17 65 38
              29 21 68 49 89 62 54 36 64 67 63 200 -1 64 -6 124 -13 136 -20 37 -109 75
              -187 80 -38 2 -81 0 -95 -5z m147 -59 c91 -30 93 -34 90 -165 -2 -113 -3 -114
              -32 -140 -17 -15 -34 -27 -39 -27 -4 0 -25 -13 -46 -30 -21 -16 -41 -30 -44
              -30 -13 0 -156 113 -157 124 -1 6 0 58 0 116 2 117 4 119 85 151 54 22 80 22
              143 1z"/>
              <path d="M903 1313 c-7 -2 -13 -13 -13 -23 0 -9 -6 -23 -14 -29 -7 -6 -16 -25
              -20 -42 -5 -24 -10 -30 -28 -27 -14 2 -24 12 -28 28 -5 20 -12 25 -35 25 -24
              0 -29 -4 -27 -20 2 -11 9 -24 15 -30 7 -5 27 -29 46 -53 18 -24 38 -41 43 -40
              6 2 25 31 43 65 18 33 40 71 49 84 22 32 21 69 -1 68 -10 0 -24 -3 -30 -6z"/>
              <path d="M563 854 c-3 -9 0 -20 8 -25 8 -5 88 -8 179 -6 158 2 165 3 165 22 0
              19 -8 20 -173 23 -152 2 -173 1 -179 -14z"/>
              <path d="M965 860 c-15 -25 17 -40 84 -40 68 0 94 11 84 36 -6 17 -158 20
              -168 4z"/>
              <path d="M573 743 c-18 -7 -16 -30 3 -37 9 -3 45 -6 80 -6 50 0 66 4 71 16 3
              9 0 20 -8 25 -15 9 -125 11 -146 2z"/>
              <path d="M773 734 c-3 -8 -2 -19 3 -24 5 -5 85 -10 177 -11 137 -3 170 0 177
              11 21 34 -8 40 -182 40 -144 0 -170 -2 -175 -16z"/>
              </g>
            </svg>

              <span>Faster policy issuance</span>
            </li>
          </ul>
        
              </div>
            </div>
            {/* <!--right-side--> */}
          </div>
        </div>
      </div>

      {/* <!--body Section--> */}
      <div className="clerfix"></div>
      {/* <!--mobile view button--> 
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure otp">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <div className="submit-btn cen">
                {" "}
                <a onClick={handleSkip}> Skip </a>{" "}
              </div>
              <div className="previous-btn cen">
                <a>
                  {" "}
                  <button
                    type="submit"
                    form="OTPverify"
                    style={{
                      backgroundColor: "transparent",
                      padding: "14px 10px",
                      border: "none",
                      color: "#fff",
                    }}
                    onClick={submitPanVerfication}
                  >
                    Proceed
                  </button>{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      */}
      {/* <!--mobile view button-->   */}

      {/* <!--mobile view button--> */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure otp2 hidden">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <div className="submit-btn cen">
                {" "}
                <a aria-hidden="true" onClick={handleSkip}> Skip </a>{" "}
              </div>
              <div className="previous-btn cen">
                <a>
                  {" "}
                  <button
                    type="submit"
                    value="otpsubmit"
                    name="otpsubmit"
                    form="OTPverify"
                    style={{
                      backgroundColor: "transparent",
                      padding: "0px 10px",
                      border: "none",
                      color: "#fff",
                    }}
                    onClick={(e) => {
                      verifyCkycOtp(e)
                    }}
                  >
                    Submit
                  </button>{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--mobile view button-->   */}
    </>
  )
}

export default Ckyc
